import { Injectable } from "@angular/core";
import { CurrentUserService } from "@gtmhub/users";
import { ISessionTreeNode } from "../models/session-tree.model";
import { PlanningSessionStatus, Session } from "../models/sessions.model";

const isSomeNodeInBranchAnOpenSession = (session: Session): boolean => {
  if (session.status === PlanningSessionStatus.OPEN) {
    return true;
  }

  if (!session.children.length) {
    return false;
  }

  for (const child of session.children) {
    const isSomeNodeInChildBranchAnOpenSession = isSomeNodeInBranchAnOpenSession(child);

    if (isSomeNodeInChildBranchAnOpenSession) {
      return true;
    }
  }

  return false;
};

@Injectable({
  providedIn: "root",
})
export class SessionSelectorUtilsService {
  constructor(private currentUserService: CurrentUserService) {}

  // IMPORTANT! because of this being a default condition it could be called from a place where this.currentUserService is not defined
  // to avoid that, this needs to be arrow function so that 'this' does not create it's own context
  // this is the default filter condition in order not to change the existing behavior
  public filterOpenSessionsInWhichUserHasRightToCreate = (sessions: Session[]): Session[] => {
    for (const session of sessions) {
      if (session.status === PlanningSessionStatus.OPEN) {
        session.userHasPermissionToCreate = this.currentUserService.allowedActionsSync(session.access).includes("create");
      } else if (isSomeNodeInBranchAnOpenSession(session)) {
        session.userHasPermissionToCreate = false;
      } else {
        sessions = sessions.filter((s) => s !== session);
      }
    }

    return sessions;
  };

  public fillSessionWithPermissions(sessions: Session[]): Session[] {
    // we copy the sessions because we do not want to have the passed reference include the permissions,
    // since they are only relevant for the caller of the method
    sessions = structuredClone(sessions);

    return this.filterOpenSessionsInWhichUserHasRightToCreate(sessions);
  }

  public isAnyChild(parent: ISessionTreeNode, predicate: (child: ISessionTreeNode) => boolean): boolean {
    if (!parent.children || !parent.children.length) {
      return false;
    }

    return parent.children.some((child) => this.isAnyChild(child, predicate));
  }
}
